(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-banner"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-collection-fit-dialog]').forEach((dialog) => {
      if (dialog.dataset.initialized === 'true') return;
      dialog.dataset.initialized = 'true';
      const section = dialog.closest('.shopify-section');
      const openButton = section?.querySelector('[data-collection-fit-open]');
      const closeButton = dialog.querySelector('[data-collection-fit-close]');
      openButton?.addEventListener('click', () => { dialog.showModal(); window.requestAnimationFrame(() => window.dispatchEvent(new Event('resize'))); });
      const closeDialog = () => {
        if (!dialog.open || dialog.classList.contains('is-closing')) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          dialog.close();
          return;
        }
        dialog.classList.add('is-closing');
        dialog.addEventListener('animationend', () => dialog.close(), { once: true });
      };
      closeButton?.addEventListener('click', closeDialog);
      dialog.addEventListener('click', (event) => { if (event.target === dialog) closeDialog(); });
      dialog.addEventListener('cancel', (event) => { event.preventDefault(); closeDialog(); });
      dialog.addEventListener('close', () => dialog.classList.remove('is-closing'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-by-function-models"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__havnbyVehicleGuideBound) return;
    window.__havnbyVehicleGuideBound = true;
    const setModel = (root, model) => {
      root.querySelectorAll('[data-vg-model]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.vgModel === model));
      });
      root.querySelectorAll('[data-vg-panel]').forEach((panel) => {
        const visible = panel.dataset.vgPanelModel === model;
        panel.hidden = !visible;
      });
    };

    const init = (root) => {
      if (!root) return;
      const panels = [...root.querySelectorAll('[data-vg-panel]')];
      const buttons = [...root.querySelectorAll('[data-vg-model]')];
      buttons.forEach((button) => {
        button.hidden = !panels.some((panel) => panel.dataset.vgPanelModel === button.dataset.vgModel);
      });
      root.hidden = !panels.length && !window.Shopify?.designMode;
      const initial = buttons.find((button) => !button.hidden);
      if (initial) setModel(root, initial.dataset.vgModel);
    };

    document.addEventListener('click', (event) => {
      const modelButton = event.target.closest('.vehicle-guide [data-vg-model]');
      if (modelButton) {
        setModel(modelButton.closest('.vehicle-guide'), modelButton.dataset.vgModel);
        return;
      }
      const scrollButton = event.target.closest('.vehicle-guide [data-vg-scroll]');
      if (!scrollButton) return;
      const list = scrollButton.closest('[data-vg-panel]').querySelector('.vehicle-guide__products');
      const card = list.querySelector('.product-card');
      const distance = card ? card.getBoundingClientRect().width + 20 : list.clientWidth * .7;
      list.scrollBy({ left: distance * (scrollButton.dataset.vgScroll === 'next' ? 1 : -1), behavior: 'smooth' });
    });

    document.addEventListener('shopify:section:load', (event) => {
      init(event.target.querySelector('.vehicle-guide'));
    });
    document.addEventListener('shopify:block:select', (event) => {
      const panel = event.target.closest('.vehicle-guide [data-vg-panel]');
      if (panel) setModel(panel.closest('.vehicle-guide'), panel.dataset.vgPanelModel);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => document.querySelectorAll('.vehicle-guide').forEach(init), { once: true });
    } else {
      document.querySelectorAll('.vehicle-guide').forEach(init);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["havnby-3d-experience"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-3d-experience')) {
    customElements.define('product-3d-experience', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const updateViewport = () => this.style.setProperty('--h3d-viewport', document.documentElement.clientWidth + 'px');
        updateViewport();
        window.addEventListener('resize', updateViewport, { signal: this.controller.signal });
        this.button = this.querySelector('.h3d__launch');
        this.button.disabled = false;
        this.button.addEventListener('click', () => this.start(), { signal: this.controller.signal });
        if (this.dataset.autoload === 'true' && !this.frame) {
          if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(entries => {
              if (entries.some(entry => entry.isIntersecting)) this.start();
            }, { rootMargin: '0px', threshold: 0.1 });
            this.observer.observe(this);
          }
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        window.clearTimeout(this.loadFallback);
      }
      start() {
        if (this.frame) return;
        let url;
        try {
          url = new URL(this.dataset.viewerUrl);
          if (url.protocol !== 'https:') return;
        } catch { return; }
        this.observer?.disconnect();
        const frame = this.querySelector('.h3d__frame-template').content.firstElementChild.cloneNode(true);
        const loading = this.querySelector('.h3d__loading');
        loading.hidden = false;
        this.frame = frame;
        const track = loading.querySelector('.h3d__loading-track');
        const time = loading.querySelector('.h3d__loading-time');
        const receiveProgress = event => {
          if (event.source !== frame.contentWindow || event.origin !== url.origin) return;
          const data = event.data;
          if (!data || data.type !== 'product-3d:loading' || !['downloading', 'preparing', 'ready'].includes(data.phase)) return;
          if (!Number.isFinite(data.progress) || !Number.isFinite(data.secondsRemaining)) return;
          this.bridgeActive = true;
          window.clearTimeout(this.loadFallback);
          const value = Math.max(0, Math.min(100, data.progress));
          if (value > 0) {
            loading.dataset.determinate = 'true';
            loading.style.setProperty('--h3d-progress', value + '%');
            track.setAttribute('aria-valuenow', String(Math.round(value)));
          }
          time.textContent = data.phase === 'preparing'
            ? loading.dataset.preparing
            : loading.dataset.remaining.replace('__SECONDS__', String(Math.max(1, Math.ceil(data.secondsRemaining))));
          if (data.phase === 'ready') loading.hidden = true;
        };
        window.addEventListener('message', receiveProgress, { signal: this.controller.signal });
        frame.addEventListener('load', () => {
          this.loadFallback = window.setTimeout(() => {
            if (!this.bridgeActive) loading.hidden = true;
          }, 1000);
        }, { once: true });
        frame.src = url.href;
        this.querySelector('.h3d__frame-host').appendChild(frame);
        this.querySelector('.h3d__poster').hidden = true;
        frame.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["havnby-approach"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-hvn-fit-dialog]').forEach((dialog) => {
    if (dialog.dataset.initialized === 'true') return;
    dialog.dataset.initialized = 'true';

    const section = dialog.closest('.shopify-section');
    const openButton = section?.querySelector('[data-hvn-fit-open]');
    const closeButton = dialog.querySelector('[data-hvn-fit-close]');

    openButton?.addEventListener('click', () => {
      if (typeof dialog.showModal !== 'function') return;
      dialog.showModal();
      window.requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
    });

    const closeDialog = () => {
      if (!dialog.open || dialog.classList.contains('is-closing')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        dialog.close();
        return;
      }
      dialog.classList.add('is-closing');
      dialog.addEventListener('animationend', () => dialog.close(), { once: true });
    };

    closeButton?.addEventListener('click', closeDialog);
    dialog.addEventListener('click', (event) => { if (event.target === dialog) closeDialog(); });
    dialog.addEventListener('cancel', (event) => { event.preventDefault(); closeDialog(); });
    dialog.addEventListener('close', () => dialog.classList.remove('is-closing'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["havnby-collection-fit-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-havnby-fit-dialog]').forEach((dialog) => {
      if (dialog.dataset.initialized === 'true') return;
      dialog.dataset.initialized = 'true';
      const section = dialog.closest('.shopify-section');
      const openButton = section?.querySelector('[data-havnby-fit-open]');
      const closeButton = dialog.querySelector('[data-havnby-fit-close]');
      openButton?.addEventListener('click', () => { dialog.showModal(); window.requestAnimationFrame(() => window.dispatchEvent(new Event('resize'))); });
      closeButton?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["havnby-comparison"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.snugnest-comparison').forEach((section) => {
    const items = section.querySelectorAll('.snugnest-comparison__item');

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        items.forEach((otherItem) => {
          if (otherItem !== item) otherItem.removeAttribute('open');
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["havnby-expert-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hvn-expert-reviews')) {
  customElements.define('hvn-expert-reviews', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.prepareReviewLinks();
      const track = this.querySelector('.hvn-experts__track');
      const controls = this.querySelector('.hvn-experts__controls');
      const prev = this.querySelector('[data-review-prev]');
      const next = this.querySelector('[data-review-next]');
      const dialog = this.querySelector('dialog');
      const player = this.querySelector('.hvn-experts__player');
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        controls.hidden = max < 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
      };
      const move = (direction) => {
        const card = track.querySelector('article');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      prev.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      track.addEventListener('scroll', update, {...options, passive:true});
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-review-video]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || typeof dialog.showModal !== 'function') return;
        const id = encodeURIComponent(link.dataset.videoId);
        const provider = link.dataset.provider;
        if (!id || !['youtube','vimeo'].includes(provider)) return;
        event.preventDefault();
        this.opener = link;
        const iframe = document.createElement('iframe');
        iframe.title = link.dataset.videoTitle;
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; fullscreen; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        iframe.src = provider === 'youtube' ? `https://www.youtube.com/embed/${id}?autoplay=1&playsinline=1&rel=0&origin=${encodeURIComponent(location.origin)}` : `https://player.vimeo.com/video/${id}?autoplay=1&playsinline=1`;
        const original = this.querySelector('.hvn-experts__original');
        original.href = provider === 'youtube' ? `https://www.youtube.com/watch?v=${id}` : `https://vimeo.com/${id}`;
        original.hidden = false;
        player.replaceChildren(iframe);
        dialog.showModal();
      }, options);
      this.querySelector('.hvn-experts__close').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', (event) => {if (event.target === dialog) dialog.close();}, options);
      dialog.addEventListener('close', () => {player.replaceChildren(); this.opener?.focus();}, options);
      this.addEventListener('shopify:block:select', (event) => {const card = event.target.closest('article'); if(card) track.scrollLeft = card.offsetLeft - track.firstElementChild.offsetLeft;}, options);
      update();
      this.loadReviewMetadata();
    }
    parseReviewUrl(raw) {
      try {
        const url = new URL(raw);
        const host = url.hostname.toLowerCase().replace(/^www\./, '');
        const parts = url.pathname.split('/').filter(Boolean);
        if (host === 'youtu.be') return {provider:'youtube',id:parts[0]};
        if (['youtube.com','m.youtube.com','youtube-nocookie.com'].includes(host)) {
          return {provider:'youtube',id:url.searchParams.get('v') || (['shorts','embed','live'].includes(parts[0]) ? parts[1] : '')};
        }
        if (['vimeo.com','player.vimeo.com'].includes(host)) return {provider:'vimeo',id:parts.find(part => /^\d+$/.test(part))};
      } catch (_) {}
      return null;
    }
    prepareReviewLinks() {
      this.querySelectorAll('[data-review-card]').forEach(card => {
        const video = this.parseReviewUrl(card.dataset.sourceUrl || card.querySelector('[data-review-video]')?.href);
        if (!video?.id) return;
        card.dataset.provider = video.provider;
        card.dataset.videoId = video.id;
        card.querySelectorAll('[data-review-video]').forEach(link => {
          link.dataset.provider = video.provider;
          link.dataset.videoId = video.id;
        });
        const existingCover = card.querySelector('[data-auto-cover]');
        if (video.provider === 'youtube' && existingCover && card.dataset.manualCover !== 'true') {
          existingCover.src = `https://i.ytimg.com/vi/${encodeURIComponent(video.id)}/hqdefault.jpg`;
        }
        if (video.provider === 'youtube' && card.dataset.manualCover !== 'true' && !card.querySelector('[data-auto-cover]')) {
          const image = document.createElement('img');
          image.dataset.autoCover = '';
          image.src = `https://i.ytimg.com/vi/${encodeURIComponent(video.id)}/hqdefault.jpg`;
          image.width = 480;
          image.height = 360;
          image.loading = 'lazy';
          image.alt = card.querySelector('.hvn-experts__title').textContent.trim();
          card.querySelector('.hvn-experts__placeholder')?.remove();
          card.querySelector('.hvn-experts__cover').prepend(image);
        }
      });
    }
    applyReviewMetadata(card, metadata) {
      if (card.dataset.manualTitle !== 'true' && metadata.title) {
        card.querySelector('.hvn-experts__title a').textContent = metadata.title;
        card.querySelectorAll('[data-review-video]').forEach(link => {
          link.dataset.videoTitle = metadata.title;
          link.setAttribute('aria-label', metadata.title);
        });
        const image = card.querySelector('[data-auto-cover]');
        if (image) image.alt = metadata.title;
      }
      if (card.dataset.manualChannel !== 'true' && metadata.author_name) {
        card.querySelector('[data-review-channel]').textContent = metadata.author_name;
        card.querySelector('.hvn-experts__channel').hidden = false;
      }
    }
    async loadReviewMetadata() {
      const signal = this.abort.signal;
      await Promise.allSettled(Array.from(this.querySelectorAll('[data-review-card]')).map(async card => {
        const id = card.dataset.videoId;
        const provider = card.dataset.provider;
        if (!id || !['youtube','vimeo'].includes(provider)) return;
        if (card.dataset.manualTitle === 'true' && card.dataset.manualChannel === 'true') return;
        const cacheKey = `hvn-review-oembed-v2:${provider}:${id}`;
        try {
          let cached;
          try {cached = JSON.parse(sessionStorage.getItem(cacheKey));} catch (_) {}
          if (cached?.data && Date.now() - cached.time < 3600000) {
            this.applyReviewMetadata(card, cached.data);
            return;
          }
          const url = provider === 'youtube' ? `https://www.youtube.com/watch?v=${encodeURIComponent(id)}` : `https://vimeo.com/${encodeURIComponent(id)}`;
          const endpoint = provider === 'youtube' ? 'https://www.youtube.com/oembed' : 'https://vimeo.com/api/oembed.json';
          const response = await fetch(`${endpoint}?url=${encodeURIComponent(url)}&format=json`, {signal});
          if (!response.ok) throw new Error(`oEmbed returned ${response.status}`);
          const data = await response.json();
          if (signal.aborted) return;
          this.applyReviewMetadata(card, data);
          try {sessionStorage.setItem(cacheKey, JSON.stringify({time:Date.now(),data:{title:data.title,author_name:data.author_name}}));} catch (_) {}
        } catch (error) {
          if (error.name !== 'AbortError') console.warn('Havnby reviews: title/author lookup failed. Confirm the video is publicly accessible, or fill in the override fields.');
        }
      }));
    }
    disconnectedCallback() {
      this.querySelector('dialog')?.close();
      this.querySelector('.hvn-experts__player')?.replaceChildren();
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["havnby-ugc-video-wheel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ugc-video-carousel')) {
    customElements.define('ugc-video-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.cards = [...this.querySelectorAll('[data-carousel-card]')];
        this.dots = [...this.querySelectorAll('[data-carousel-dot]')];
        this.previousButton = this.querySelector('[data-carousel-previous]');
        this.nextButton = this.querySelector('[data-carousel-next]');
        this.activeIndex = 0;
        this.timer = null;
        this.pointerStartX = null;

        if (!this.track || !this.cards.length) return;

        this.previousButton?.addEventListener('click', () => this.step(-1));
        this.nextButton?.addEventListener('click', () => this.step(1));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.carouselDot))));

        this.querySelectorAll('[data-video-play]').forEach((button) => {
          button.addEventListener('click', (event) => {
            event.stopPropagation();
            this.playVideo(button.closest('[data-carousel-card]'));
          });
        });

        this.cards.forEach((card, index) => {
          card.addEventListener('click', () => {
            if (index !== this.activeIndex) this.goTo(index);
          });
        });

        this.track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.step(-1);
          if (event.key === 'ArrowRight') this.step(1);
        });

        this.track.addEventListener('pointerdown', (event) => {
          this.pointerStartX = event.clientX;
        });

        this.track.addEventListener('pointerup', (event) => {
          if (this.pointerStartX === null) return;
          const distance = event.clientX - this.pointerStartX;
          this.pointerStartX = null;
          if (Math.abs(distance) < 40) return;
          this.step(distance > 0 ? -1 : 1);
        });

        this.track.addEventListener('pointercancel', () => { this.pointerStartX = null; });

        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => this.startAutoplay());
        document.addEventListener('visibilitychange', this.handleVisibility = () => {
          if (document.hidden) this.stopAutoplay();
          else this.startAutoplay();
        });

        this.resizeObserver = new ResizeObserver(() => this.render());
        this.resizeObserver.observe(this.track);
        this.render();
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        this.resizeObserver?.disconnect();
        document.removeEventListener('visibilitychange', this.handleVisibility);
      }

      step(direction) {
        this.goTo((this.activeIndex + direction + this.cards.length) % this.cards.length);
      }

      goTo(index) {
        if (index === this.activeIndex) return;
        this.pauseAllVideos();
        this.activeIndex = index;
        this.render();
        this.restartAutoplay();
      }

      render() {
        const count = this.cards.length;
        const cardWidth = this.cards[0]?.offsetWidth || 300;
        const gap = parseFloat(getComputedStyle(this).getPropertyValue('--ugc-section-gap')) || 24;
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const desiredDistance = (cardWidth + gap) * 0.68;
        const safeEdge = 24;
        const outerScale = 0.8;
        const availableDistance = Math.max(
          cardWidth * 0.36,
          (this.track.clientWidth / 2 - cardWidth * outerScale / 2 - safeEdge) / 2
        );
        const distance = isMobile
          ? (cardWidth + gap) * 0.62
          : Math.min(desiredDistance, availableDistance);

        this.cards.forEach((card, index) => {
          let offset = index - this.activeIndex;
          if (offset > count / 2) offset -= count;
          if (offset < -count / 2) offset += count;

          const previousOffset = Number(card.dataset.wheelOffset);
          if (Number.isFinite(previousOffset) && Math.abs(previousOffset - offset) > 1) {
            card.classList.add('is-repositioning');
            requestAnimationFrame(() => card.classList.remove('is-repositioning'));
          }

          const active = index === this.activeIndex;
          const depth = Math.abs(offset);
          const visible = depth <= 2;
          const scale = active ? 1 : depth === 1 ? 0.9 : 0.8;
          const verticalOffset = active ? 0 : depth === 1 ? 12 : 24;
          card.dataset.wheelOffset = String(offset);
          card.style.setProperty('--ugc-x', `${offset * distance}px`);
          card.style.setProperty('--ugc-y', `${verticalOffset}px`);
          card.style.setProperty('--ugc-scale', String(scale));
          card.style.setProperty('--ugc-opacity', visible ? '1' : '0');
          card.style.zIndex = String(100 - depth);
          card.style.pointerEvents = visible ? 'auto' : 'none';
          card.classList.toggle('is-active', active);
          card.setAttribute('aria-hidden', active ? 'false' : 'true');

          const playButton = card.querySelector('[data-video-play]');
          if (playButton) playButton.tabIndex = active ? 0 : -1;
          const video = card.querySelector('video');
          if (video) video.tabIndex = active ? 0 : -1;
        });

        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === this.activeIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }

      pauseAllVideos() {
        this.querySelectorAll('video').forEach((video) => {
          video.pause();
          video.closest('[data-carousel-card]')?.classList.remove('is-playing');
        });
      }

      playVideo(card) {
        if (!card) return;

        let video = card.querySelector('video');
        if (!video) {
          const template = card.querySelector('[data-video-template]');
          const media = card.querySelector('.ugc-video-carousel__media');
          if (!template || !media) return;
          media.insertBefore(template.content.cloneNode(true), media.firstChild);
          video = media.querySelector('video');
        }
        if (!video) return;

        this.pauseAllVideos();

        card.classList.add('is-playing');
        this.stopAutoplay();
        video.load();
        video.play().catch(() => card.classList.remove('is-playing'));
        video.addEventListener('pause', () => card.classList.remove('is-playing'), { once: true });
        video.addEventListener('ended', () => card.classList.remove('is-playing'), { once: true });
      }

      startAutoplay() {
        if (this.dataset.autoplay !== 'true' || this.cards.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.stopAutoplay();
        const interval = Number(this.dataset.interval) || 5000;
        this.timer = window.setInterval(() => this.step(1), interval);
      }

      stopAutoplay() {
        window.clearInterval(this.timer);
        this.timer = null;
      }

      restartAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
